// extracted by mini-css-extract-plugin
export default {"switch":"Switcher_switch__l6J20","slider":"Switcher_slider__h6337"};